import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var CellImage = /*#__PURE__*/memo(function (_ref) {
  var _cn;
  var alt = _ref.alt,
    src = _ref.src,
    custom = _ref.custom,
    size = _ref.size,
    icon = _ref.icon,
    disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('image-wrapper', (_cn = {}, _defineProperty(_cn, "image-wrapper--basic-".concat(size), size), _defineProperty(_cn, 'image-wrapper--icon', icon), _defineProperty(_cn, 'image-wrapper--disabled', disabled), _cn)),
    "data-t-id": "components-CellImage"
  }, src && /*#__PURE__*/React.createElement("img", {
    alt: alt,
    className: cn('image'),
    src: src
  }), custom, icon);
});